import SportsIcon from "@material-ui/icons/Sports";
import DateRangeIcon from "@material-ui/icons/DateRange";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
import { useMediaQuery } from "@material-ui/core";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import FeaturedPlayList from "@material-ui/icons/FeaturedPlayList";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import SettingsIcon from "@material-ui/icons/Settings";
import Textsms from "@material-ui/icons/Textsms";
import { FC, memo } from "react";
import { getResources, MenuItemLink, MenuProps } from "react-admin";
import { useSelector } from "react-redux";
import PolicyIcon from "@material-ui/icons/Policy";
import SettingsApplicationsIcon from "@material-ui/icons/SettingsApplications";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import LabelIcon from "@material-ui/icons/Label";

import useIsAdmin from "../../hooks/useIsAdmin";
import useIsAgent from "../../hooks/useIsAgent";
import useIsStore from "../../hooks/useIsStore";
import colors from "../../theme/colors";
import { ReduxState } from "../../types/redux.types";
import { AppResource } from "../../types/resource.types";
import { areEqual } from "../../utils/generic";
import SidebarIconWrapper from "../SidebarIconWrapper";
import useIsSportsClub from "../../hooks/useIsSportsClub";
import useIsGym from "../../hooks/useIsGym";
import useIsAcademy from "../../hooks/useIsAcademy";
import useIsCoach from "../../hooks/useIsCoach";
import useIsEntertainment from "../../hooks/useIsEntertainment";

const Menu: FC<MenuProps> = ({ onMenuClick, logout }) => {
  const isXSmall = useMediaQuery((theme: any) => theme.breakpoints.down("xs"));
  const resources = useSelector(getResources);

  const open = useSelector<ReduxState, boolean>((state) => state.admin.ui.sidebarOpen);
  const lists = useSelector<ReduxState, any>((state: any) => state.lists);
  const hasNotification = useSelector<ReduxState, boolean>((state) => state.chat.hasNotification);

  const { isAdmin } = useIsAdmin();
  const { isStore } = useIsStore();
  const { isSportsClub } = useIsSportsClub();
  const { isAgent } = useIsAgent();
  const { isGym } = useIsGym();
  const { isAcademy } = useIsAcademy();
  const { isCoach } = useIsCoach();
  const { isEntertainment } = useIsEntertainment();

  return (
    <>
      {resources.map((resource) => {
        return resource.hasList ? (
          <MenuItemLink
            key={resource.name}
            to={`/${resource.name}`}
            primaryText={(resource.options && resource.options.label) || resource.name}
            style={{ color: colors.menu.text }}
            leftIcon={
              <SidebarIconWrapper
                IconComponent={resource.icon}
                size="default"
                showBullet={lists[resource.name] && lists[resource.name].hasNotification}
              />
            }
            onClick={onMenuClick}
            sidebarIsOpen={open}
          />
        ) : null;
      })}
      {isAdmin && (
        <MenuItemLink
          to={`/${AppResource.reviews}`}
          primaryText={"Reviews"}
          style={{ color: colors.menu.text }}
          leftIcon={<SportsIcon style={{ color: colors.menu.icon }} />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}
      {isAdmin && (
        <MenuItemLink
          to={`/${AppResource.reservations}`}
          primaryText={"Reservations"}
          style={{ color: colors.menu.text }}
          leftIcon={<LabelIcon style={{ color: colors.menu.icon }} />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}
      {isStore && (
        <>
          <MenuItemLink
            to={`/${AppResource.brandsDeliveryMethods}`}
            primaryText={"Delivery Methods"}
            style={{ color: colors.menu.text }}
            leftIcon={<AllInboxIcon style={{ color: colors.menu.icon }} />}
            onClick={onMenuClick}
            sidebarIsOpen={open}
          />
          <MenuItemLink
            to={`/${AppResource.brandsMedia}`}
            primaryText={"Media"}
            style={{ color: colors.menu.text }}
            leftIcon={<PhotoLibraryIcon style={{ color: colors.menu.icon }} />}
            onClick={onMenuClick}
            sidebarIsOpen={open}
          />
        </>
      )}

      {isCoach && (
        <>
          <MenuItemLink
            to={`/${AppResource.coachAvailabilities}`}
            primaryText="Availabilities"
            style={{ color: colors.menu.text }}
            leftIcon={<SettingsEthernetIcon style={{ color: colors.menu.icon }} />}
            onClick={onMenuClick}
            sidebarIsOpen={open}
          />
          <MenuItemLink
            to={`/${AppResource.coachSlotsCalendar}`}
            primaryText="Calendar"
            style={{ color: colors.menu.text }}
            leftIcon={<DateRangeIcon style={{ color: colors.menu.icon }} />}
            onClick={onMenuClick}
            sidebarIsOpen={open}
          />
        </>
      )}

      {!isAgent && (
        <MenuItemLink
          to={`/${AppResource.chat}/rooms`}
          primaryText="Chat"
          style={{ color: colors.menu.text }}
          leftIcon={<SidebarIconWrapper showBullet={hasNotification} IconComponent={Textsms} />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}
      {/* {isAdmin && (
        <MenuItemLink
          to={`/materials`}
          primaryText={"Materials"}
          style={{ color: colors.menu.text }}
          leftIcon={<VideoLibraryIcon style={{ color: colors.menu.icon }} />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )} */}
      {isAdmin && (
        <MenuItemLink
          to={`/${AppResource.settings}`}
          primaryText={"Settings"}
          style={{ color: colors.menu.text }}
          leftIcon={<SettingsIcon style={{ color: colors.menu.icon }} />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}
      {isAdmin && (
        <MenuItemLink
          to={`/${AppResource.cancellationPolicies}`}
          primaryText={"Cancel Policies"}
          style={{ color: colors.menu.text }}
          leftIcon={<PolicyIcon style={{ color: colors.menu.icon }} />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}
      {isAdmin && (
        <MenuItemLink
          to={`/${AppResource.terms}`}
          primaryText={"Terms"}
          style={{ color: colors.menu.text }}
          leftIcon={<FeaturedPlayList style={{ color: colors.menu.icon }} />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}
      {(isSportsClub || isStore || isGym || isAcademy || isCoach || isEntertainment) && (
        <MenuItemLink
          to={`/${AppResource.settings}`}
          primaryText={"Settings"}
          style={{ color: colors.menu.text }}
          leftIcon={<SettingsIcon style={{ color: colors.menu.icon }} />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}
      {isGym && (
        <MenuItemLink
          to={`/${AppResource.management}`}
          primaryText={"Mangement"}
          style={{ color: colors.menu.text }}
          leftIcon={<SettingsApplicationsIcon style={{ color: colors.menu.icon }} />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      )}
      {isXSmall && logout}
    </>
  );
};

export default memo(Menu, areEqual);
